import type { ProjectsBatchAssignUsersProps } from "./projects-batch-assign-users.type";

import { useTranslation } from "react-i18next";

import BatchEditForm from "@/modules/batch-edit-form";
import UsersSelect from "@/modules/users/users-select";

import { useProjectsBatchAssignUsers } from "./projects-batch-assign-users.hook";

export const ProjectsBatchAssignUsers = ({
  projects,
}: ProjectsBatchAssignUsersProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useProjectsBatchAssignUsers(projects);

  return (
    <BatchEditForm
      modelKey="project"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <UsersSelect
        name={fieldName}
        label={t("global:assignForm.users.label")}
        placeholder={t("global:assignForm.users.placeholder")}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};
